"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sidelineSportsResultFactory = exports.sidelineSportsTrainingFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.sidelineSportsTrainingFactory = Factory.Sync.makeFactory({
    id: Factory.each(() => uuid_1.v4()),
    course: 'sideline_sports',
    personaId: mocks_1.persona.id,
    loginUrl: 'http://example.com',
    dateCompleted: mocks_1.dates.date2100,
    ssdUsername: 'test',
    ssdPassword: 'test2',
    certificateNumber: '1234567890',
});
exports.sidelineSportsResultFactory = Factory.Sync.makeFactory({
    result: [
        exports.sidelineSportsTrainingFactory.build()
    ]
});
